import { Component, OnInit, inject, signal } from '@angular/core';
import {
  AdminSkeletonComponent,
  AdminStatCardComponent,
} from '../../../shared/admin';
import {
  PlatformDashboardService,
  type PlatformDashboardStats,
} from '../../../shared/services/platform-dashboard.service';
import { DashboardTaskReminderBannerComponent } from './dashboard-task-reminder-banner.component';
import { DashboardFunnelSectionComponent } from './dashboard-funnel-section.component';

@Component({
  selector: 'app-dashboard-page',
  standalone: true,
  imports: [
    AdminSkeletonComponent,
    AdminStatCardComponent,
    DashboardTaskReminderBannerComponent,
    DashboardFunnelSectionComponent,
  ],
  templateUrl: './dashboard-page.component.html',
  styleUrl: './dashboard-page.component.scss',
})
export class DashboardPageComponent implements OnInit {
  private readonly dashboardService = inject(PlatformDashboardService);

  readonly stats = signal<PlatformDashboardStats | null>(null);
  readonly loading = signal(true);
  readonly error = signal<string | null>(null);

  ngOnInit() {
    this.dashboardService.getStats().subscribe({
      next: (data) => {
        this.stats.set(data);
        this.loading.set(false);
      },
      error: () => {
        this.error.set('Unable to load dashboard stats.');
        this.loading.set(false);
      },
    });
  }

  formatRate(rate: number): string {
    return `${rate}%`;
  }
}
